import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";

import { routers } from "@/configs";
import MainLayout from "@/layout";
import CasinoLayout from "@/layout/Casino";

import { CasinoRoutes, GameRoomRoutes } from "./Casino";
import { MainRoutes } from "./Main";
import { OthersRoutes } from "./Others";
import PrivateRoute from "./PrivateRoute";
import { ProfileRoutes } from "./Profile";
import RouteErrorBoundary from "./RouteErrorBoundary";
import { SportRoutes } from "./Sport";

// Lazy: the sportsbook layout and its hooks are ~100 KB a casino visit never needs.
const SportLayout = lazy(() => import("@/layout/Sport"));
const IconsList = lazy(() => import("@/pages/Others/Icons"));
const NotFound = lazy(() => import("@/pages/Others/NotFound"));
const Loading = lazy(() => import("@/components/Core/Loading"));

const routes = createBrowserRouter([
  {
    path: "/",
    element: <CasinoLayout />,
    errorElement: <RouteErrorBoundary />,
    children: [...CasinoRoutes],
  },
  {
    path: "/",
    element: <MainLayout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      ...OthersRoutes,
      {
        path: routers.NotFound,
        element: <NotFound />,
      },
      {
        path: routers.Loading,
        element: <Loading />,
      },
      {
        path: routers.Icons,
        element: <IconsList />,
      },
    ],
  },
  {
    path: "/",
    element: <MainLayout hideFooter />,
    errorElement: <RouteErrorBoundary />,
    children: [...GameRoomRoutes],
  },
  {
    path: "/",
    element: <SportLayout />,
    errorElement: <RouteErrorBoundary />,
    children: [...SportRoutes],
  },
  {
    path: "/",
    element: (
      <PrivateRoute>
        <MainLayout />
      </PrivateRoute>
    ),
    errorElement: <RouteErrorBoundary />,
    children: [...MainRoutes, ...ProfileRoutes],
  },
]);

export default routes;
